import { Button, Card, Flex, Icon, Text } from '@homebotapp/hb-react-component-catalog'
import { AddPreferredAgentModal } from './AddPreferredAgent/AddPreferredAgentModal'
import { useState } from 'react'
import { defineMessages, useIntl } from 'react-intl'

interface AddAgentCardProps {
  clientId: string
  customerType?: 'RealEstateAgent' | 'LoanOfficer' | 'InsuranceAgent' | 'TitleAgent'
}

export const MSG = defineMessages({
  addRealEstateAgentCardTitle: {
    id: 'addRealEstateAgentCardTitle',
    defaultMessage: 'Add a real estate agent to your team'
  },
  addRealEstateAgentCardDescription: {
    id: 'addRealEstateAgentCardDescription',
    defaultMessage: 'Adding a real estate agent lets you reach them directly while exploring Homebot.'
  },
  addRealEstateAgentButton: {
    id: 'addRealEstateAgentButton',
    defaultMessage: 'Add real estate agent'
  },
  addInsuranceAgentCardTitle: {
    id: 'addInsuranceAgentCardTitle',
    defaultMessage: 'Add an insurance agent to your team'
  },
  addInsuranceAgentCardDescription: {
    id: 'addInsuranceAgentCardDescription',
    defaultMessage: 'Adding an insurance agent lets you reach them directly while exploring Homebot.'
  },
  addInsuranceAgentButton: {
    id: 'addInsuranceAgentButton',
    defaultMessage: 'Add insurance agent'
  },
  addLoanOfficerCardTitle: {
    id: 'addLoanOfficerCardTitle',
    defaultMessage: 'Add a loan officer to your team'
  },
  addLoanOfficerCardDescription: {
    id: 'addLoanOfficerCardDescription',
    defaultMessage: 'Adding a loan officer lets you reach them directly while exploring Homebot.'
  },
  addLoanOfficerButton: {
    id: 'addLoanOfficerButton',
    defaultMessage: 'Add loan officer'
  }
})

export const AddAgentCard = ({ clientId, customerType = 'RealEstateAgent' }: AddAgentCardProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const intl = useIntl()

  const getMessages = () => {
    switch (customerType) {
      case 'LoanOfficer':
        return {
          title: MSG.addLoanOfficerCardTitle,
          description: MSG.addLoanOfficerCardDescription,
          button: MSG.addLoanOfficerButton
        }
      case 'InsuranceAgent':
        return {
          title: MSG.addInsuranceAgentCardTitle,
          description: MSG.addInsuranceAgentCardDescription,
          button: MSG.addInsuranceAgentButton
        }
      case 'RealEstateAgent':
      default:
        return {
          title: MSG.addRealEstateAgentCardTitle,
          description: MSG.addRealEstateAgentCardDescription,
          button: MSG.addRealEstateAgentButton
        }
    }
  }

  const messages = getMessages()

  return (
    <>
      <Card
        display='flex'
        data-qa={`Add${customerType}Card`}
        justifyContent='left'
        flexDirection='column'
        alignItems='flex-start'
        textAlign='left'
        width='375px'
      >
        <Flex display='flex' flexDirection='column' alignItems='flex-start' p={4}>
          <Text size='lg' fontWeight='semibold' color='neutral.900'>
            {intl.formatMessage(messages.title)}
          </Text>
          <Text color='neutral.700' size='sm' textAlign='left'>
            {intl.formatMessage(messages.description)}
          </Text>
          <Button
            mt={4}
            colorScheme='primary'
            onClick={() => setIsModalOpen(true)}
            alignSelf='flex-start'
            tracking={{
              guid: 'vR2k9PwdXzNgkAAeKuyVBn',
              ui_context: `Add ${customerType.toLowerCase()} card add agent`,
              descriptor: `Add ${customerType.toLowerCase()} button clicked`
            }}
          >
            <Icon name='plus-btb' mr={2} h='12px' w='12px' />
            {intl.formatMessage(messages.button)}
          </Button>
        </Flex>
      </Card>

      <AddPreferredAgentModal
        clientId={clientId}
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        customerType={customerType}
      />
    </>
  )
}
